var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncementsFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2501 16.322L10.1344 4.21398L5.27811 11.3364L7.41497 15.6098L15.2501 16.322Z",
    fill: "#2F3237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2319 3.23594C10.5899 3.27162 10.8998 3.50005 11.0398 3.83147L16.1556 15.9395C16.29 16.2576 16.2476 16.6229 16.0439 16.9018C15.8402 17.1806 15.505 17.3321 15.1611 17.3009L7.32597 16.5886C6.98696 16.5578 6.68802 16.3538 6.53579 16.0494L4.39893 11.7759C4.23955 11.4572 4.26519 11.0771 4.46596 10.7827L9.32222 3.6603C9.52491 3.36304 9.87383 3.20026 10.2319 3.23594ZM9.93071 6.25751L6.41546 11.4131L8.04927 14.6805L13.7068 15.1948L9.93071 6.25751Z",
    fill: "#2F3237"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98938 11.8817C2.47494 11.639 3.06537 11.8358 3.30815 12.3213L6.86958 19.4437C7.11236 19.9292 6.91554 20.5196 6.42999 20.7623C5.94443 21.0051 5.35399 20.8083 5.11121 20.3228L1.54979 13.2004C1.30701 12.7149 1.50382 12.1245 1.98938 11.8817Z",
    fill: "#2F3237"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9204 5.9636C23.1342 6.46255 22.9031 7.04037 22.4041 7.2542L17.4181 9.39091C16.9191 9.60475 16.3413 9.37362 16.1274 8.87468C15.9136 8.37573 16.1447 7.79791 16.6437 7.58408L21.6297 5.44736C22.1287 5.23353 22.7065 5.46466 22.9204 5.9636Z",
    fill: "#2F3237"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8141 12.8658C20.634 13.3779 20.0729 13.647 19.5608 13.467L17.7801 12.8409C17.268 12.6608 16.9988 12.0997 17.1789 11.5876C17.359 11.0755 17.9201 10.8064 18.4322 10.9864L20.2129 11.6125C20.725 11.7926 20.9942 12.3537 20.8141 12.8658Z",
    fill: "#2F3237"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7369 6.08507C15.1999 6.36851 15.805 6.22299 16.0885 5.76003L17.1569 4.01505C17.4404 3.55209 17.2949 2.94701 16.8319 2.66357C16.3689 2.38013 15.7638 2.52565 15.4803 2.98861L14.4119 4.73359C14.1284 5.19655 14.2739 5.80162 14.7369 6.08507Z",
    fill: "#2F3237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementsFilled);
export default __webpack_public_path__ + "static/media/announcements_filled.9b7266d9bce931c924de0aa33897737b.svg";
export { ForwardRef as ReactComponent };